const SYSTEM_ADMIN_ID = 1; 
const TEACHER_ROLE_ID = 5;

export {SYSTEM_ADMIN_ID, TEACHER_ROLE_ID};